import { FC, RefObject } from 'react';
import { ContextMenu } from '../ContextMenu/ContextMenu';
import { widgetTypes } from 'builder/util/constants';

interface WidgetWrapperContextMenuProps {
  contextMenuRef: RefObject<HTMLDivElement>;
  contextMenuPosition: { x: number; y: number };
  widgetId: string;
  widgetState: any;
  layoutLocked: boolean;
  selectedWidgetIds: string[];
  onOpenSettings: () => void;
  onDeleteWidget: () => void;
  onDuplicateWidget: () => void;
  onDownloadWidget: () => void;
  onSaveToMyWidgets: () => void;
  onGroupWidgets: () => void;
  onUngroupWidgets: () => void;
  isDisabled: (widgetId: string) => boolean;
  isConfigEnabled: (widgetType: string) => boolean;
}

const WidgetWrapperContextMenu: FC<WidgetWrapperContextMenuProps> = ({
  contextMenuRef,
  contextMenuPosition,
  widgetId,
  widgetState,
  layoutLocked,
  selectedWidgetIds,
  onOpenSettings,
  onDeleteWidget,
  onDuplicateWidget,
  onDownloadWidget,
  onSaveToMyWidgets,
  onGroupWidgets,
  onUngroupWidgets,
  isDisabled,
  isConfigEnabled,
}) => {
  const isRepeaterWidget = widgetState.type === widgetTypes.RepeaterWidget;

  const menuItems = [
    selectedWidgetIds.length <= 1 && {
      label: 'View Settings',
      action: onOpenSettings,
      enableOption: layoutLocked ? isConfigEnabled(widgetState.type) : true,
    },
    {
      label: 'Delete',
      action: onDeleteWidget,
      shortcut: '\u2318 + ⌫',
    },
    selectedWidgetIds.length <= 1 &&
      !isRepeaterWidget && {
        label: 'Duplicate',
        action: onDuplicateWidget,
        shortcut: '\u2318 + D',
      },
    selectedWidgetIds.length <= 1 &&
      !isRepeaterWidget && {
        label: 'Download',
        action: onDownloadWidget,
      },
    selectedWidgetIds.length <= 1 &&
      !isRepeaterWidget && {
        label: 'Save to My Widgets',
        action: onSaveToMyWidgets,
      },
    selectedWidgetIds.length > 1 && {
      label: 'Group Widgets',
      action: onGroupWidgets,
      enableOption: true,
    },
    selectedWidgetIds.length > 1 && {
      label: 'Ungroup Widgets',
      action: onUngroupWidgets,
      enableOption: true,
    },
  ].filter(Boolean);

  return (
    <ContextMenu
      ref={contextMenuRef}
      disabled={isDisabled(widgetId) || layoutLocked}
      key={widgetState.id}
      menuitems={menuItems}
      position={contextMenuPosition}
    />
  );
};

export default WidgetWrapperContextMenu;
